import { render } from "./SifatSuratRadio.vue?vue&type=template&id=689f2a82&scoped=true"
import script from "./SifatSuratRadio.vue?vue&type=script&lang=js"
export * from "./SifatSuratRadio.vue?vue&type=script&lang=js"

import "./SifatSuratRadio.vue?vue&type=style&index=0&id=689f2a82&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689f2a82"]])

export default __exports__